<template>
  <div class="layout-frame">
    <PageIntro :title="t('forgotPassword.title')" :subtitle="t('forgotPassword.subtitle')" />
    <!-- <ForgotPasswordForm /> -->
  </div>
</template>

<script setup lang="ts">
// import ForgotPasswordForm from '@modules/ForgotPasswordForm.vue';
import { useI18n } from 'vue-i18n';

// Components
import PageIntro from '@modules/PageIntro.vue';

const { t } = useI18n();
</script>
